import isEqual from 'lodash/isEqual';
import type {ManifestationV4, MetadataExports} from '../types';
import {getManifestationExportProps} from './getManifestationExportProps';

export const updateManifestationExportProps = (
  manifestation: ManifestationV4,
  currentExports: MetadataExports | undefined,
): MetadataExports => {
  const newProps = getManifestationExportProps(manifestation);
  return currentExports
    ? isEqual(currentExports.manifestations[manifestation.id], newProps)
      ? currentExports
      : {
          ...currentExports,
          manifestations: {
            ...currentExports.manifestations,
            [manifestation.id]: newProps,
          },
        }
    : {
        work: {
          type: 'BOOK',
        },
        expressions: {},
        manifestations: {
          [manifestation.id]: newProps,
        },
      };
};
